import { Shield, AlertTriangle } from "lucide-react";
import { StepHeader } from "./StepHeader";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface AgeGateStepProps {
  icon: typeof Shield;
  title: string;
  description: string;
  isAgeVerified: boolean;
  setIsAgeVerified: (verified: boolean) => void;
}

export function AgeGateStep({
  icon: Icon,
  title,
  description,
  isAgeVerified,
  setIsAgeVerified,
}: AgeGateStepProps) {
  return (
    <div className="w-full max-w-md space-y-6">
      <StepHeader icon={Icon} title={title} description={description} />

      <div className="space-y-6">
        <div className="p-4 rounded-lg bg-muted/50 border border-border">
          <div className="flex items-start gap-3">
            <AlertTriangle className="w-5 h-5 text-yellow-500 mt-0.5 flex-shrink-0" />
            <div className="space-y-2">
              <p className="text-sm text-foreground">
                Evolve is a fitness coaching app designed for users <strong>16 years of age or older</strong>.
              </p>
              <p className="text-xs text-muted-foreground">
                By continuing, you confirm that you meet this age requirement. If you're under 16, please ask a parent or guardian for assistance.
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-start space-x-3 p-4 rounded-lg border border-border bg-card">
          <Checkbox
            id="age-confirmation"
            checked={isAgeVerified}
            onCheckedChange={(checked) => setIsAgeVerified(checked === true)}
            className="mt-0.5"
          />
          <Label 
            htmlFor="age-confirmation" 
            className="text-sm leading-relaxed cursor-pointer"
          >
            I confirm that I am <strong>16 years of age or older</strong> and agree to use Evolve responsibly.
          </Label>
        </div>

        <div className="p-4 rounded-lg bg-primary/5 border border-primary/20">
          <div className="flex items-start gap-3">
            <Shield className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
            <div className="space-y-1">
              <p className="text-sm font-medium text-foreground">Your Privacy Matters</p>
              <p className="text-xs text-muted-foreground">
                Evolve does not collect personal information from children under 16. We're committed to protecting your privacy and providing a safe fitness experience.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
